import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileItem } from '../types/File/File.types';

interface UseRenameProps {
    item: FileItem | null;
    onConfirm: (name: string) => void;
}

interface FileNameParts {
    base: string;
    ext: string;
}

const useRename = ({ item, onConfirm }: UseRenameProps) => {
    const [nameParts, setNameParts] = useState<FileNameParts>({ base: '', ext: '' });
    const [error, setError] = useState('');
    const { t } = useTranslation();

    const getNameParts = (name: string) => {
        const lastDot = name.lastIndexOf('.');
        if (item?.type === 'file' && lastDot > 0) {
            return {
                base: name.substring(0, lastDot),
                ext: name.substring(lastDot),
            };
        }
        return { base: name, ext: '' };
    };

    useEffect(() => {
        const { base, ext } = getNameParts(item?.name || '');

        if (item) {
            setNameParts({ base, ext });
            setError('');
        }
    }, [item]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!nameParts.base.trim()) {
            setError('El nombre no puede estar vacío');
            return;
        }

        if (/[\\/:*?"<>|]/.test(nameParts.base)) {
            setError(String.raw`El nombre no puede contener los siguientes caracteres: \ / : * ? " < > |`);
            return;
        }

        // Concatenar base y extensión
        onConfirm(nameParts.base + nameParts.ext);
    };

    return {
        getNameParts,
        nameParts,
        error,
        handleSubmit,
        setNameParts,
        setError,
        t,
    };
};

export default useRename;
